export const roundToDistanceInKmDecimal = (distance: number): number => Math.floor(distance / 100) / 10;

export const roundToDistanceInKm = (distance: number): number => Math.floor(distance / 1000);
